import { render, staticRenderFns } from "./Guest_supplements.vue?vue&type=template&id=8e41352c&scoped=true&"
import script from "./Guest_supplements.vue?vue&type=script&lang=js&"
export * from "./Guest_supplements.vue?vue&type=script&lang=js&"
import style0 from "./Guest_supplements.vue?vue&type=style&index=0&id=8e41352c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e41352c",
  null
  
)

export default component.exports